var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGrayDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 2.003a1.667 1.667 0 113.333 0 1.667 1.667 0 01-3.333 0zm-5 0a1.667 1.667 0 113.333 0 1.667 1.667 0 01-3.333 0zm-5 0a1.667 1.667 0 113.333 0 1.667 1.667 0 01-3.333 0z",
    fill: "#A8A9AC"
  })));
}

export default SvgIconGrayDots;